import React from 'react';
import { LinkButton } from 'fronton-react';
import { useSelector } from 'react-redux';
import { getPathname } from 'common/selectors';
import { reviewAdditionalInfoWrapper, reviewTextAlignLeft, reviewVariantNotPointer } from './review.styles';
import { getIsGroupRatings } from 'features/reviews/selectors';

type ReviewVariantStringProps = {
  variantLink?: string;
  variantString?: string;
};

export const ReviewVariantString: React.FC<ReviewVariantStringProps> = ({ variantLink, variantString }) => {
  const currentPathname = useSelector(getPathname);
  const variantPathname = variantLink ? variantLink : undefined;
  const isCurrentPage = Boolean(variantPathname && currentPathname?.startsWith(variantPathname));
  const isGroupRatings = useSelector(getIsGroupRatings);

  if (!variantString || !isGroupRatings) return null;
  return (
    <div className={reviewAdditionalInfoWrapper}>
      {isCurrentPage ? (
        <LinkButton variant="secondary" size="s" className={reviewVariantNotPointer}>
          {variantString}
        </LinkButton>
      ) : (
        <LinkButton href={variantLink} variant="underline" size="s" className={reviewTextAlignLeft}>
          {variantString}
        </LinkButton>
      )}
    </div>
  );
};
